import React from 'react';
// Mock data for properties
export const mockProperties = [{
  id: 'prop1',
  name: 'Riverside Apartments',
  type: 'Residential',
  address: '123 River Road, Riverside, CA 92501',
  description: 'A modern apartment complex with 24 units located in the heart of Riverside. Features include a swimming pool, gym, and community garden.',
  imageUrl: 'https://images.unsplash.com/photo-1605276374104-dee2a0ed3cd6?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
  size: 32000,
  value: 4800000,
  purchaseDate: '2019-05-15',
  yearBuilt: 2015,
  condition: 'Excellent',
  currentUse: 'Residential Rental',
  occupancy: 92,
  investmentStrategy: 'Long-Term Hold',
  expectedHoldPeriod: '7-10 years',
  annualCashFlow: 210000,
  capRate: 4.4
}, {
  id: 'prop2',
  name: 'Downtown Office Building',
  type: 'Commercial',
  address: '456 Main Street, Metropolis, NY 10001',
  description: 'A 12-story office building in the financial district with modern amenities, including high-speed internet, conference rooms, and a rooftop terrace.',
  imageUrl: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
  size: 45000,
  value: 12500000,
  purchaseDate: '2017-11-20',
  yearBuilt: 2005,
  condition: 'Good',
  currentUse: 'Office Space',
  occupancy: 78,
  investmentStrategy: 'Long-Term Hold',
  expectedHoldPeriod: '10+ years',
  annualCashFlow: 750000,
  capRate: 6.0
}, {
  id: 'prop3',
  name: 'Westside Industrial Park',
  type: 'Industrial',
  address: '789 Factory Lane, Industry City, TX 75001',
  description: 'A large industrial complex with 5 warehouse units and office spaces. Strategically located near major highways for easy distribution access.',
  imageUrl: 'https://images.unsplash.com/photo-1553502182-a338429782bc?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
  size: 85000,
  value: 7200000,
  purchaseDate: '2020-03-10',
  yearBuilt: 2010,
  condition: 'Fair',
  currentUse: 'Manufacturing & Storage',
  occupancy: 100,
  investmentStrategy: 'Long-Term Hold',
  expectedHoldPeriod: '5-7 years',
  annualCashFlow: 540000,
  capRate: 7.5
}, {
  id: 'prop4',
  name: 'Hilltop Development Land',
  type: 'Land',
  address: '101 Hilltop View, Mountain City, CO 80401',
  description: 'A 5-acre parcel of undeveloped land with beautiful mountain views. Zoned for residential development with utilities already available at the property line.',
  imageUrl: 'https://images.unsplash.com/photo-1500382017468-9049fed747ef?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
  size: 217800,
  value: 950000,
  purchaseDate: '2021-07-22',
  yearBuilt: null,
  condition: 'N/A',
  currentUse: 'Vacant',
  occupancy: 0,
  investmentStrategy: 'Short-Term Flip',
  expectedHoldPeriod: '1-2 years',
  projectedProfit: 350000,
  projectedROI: 36.8
}, {
  id: 'prop5',
  name: 'Sunset Retail Center',
  type: 'Commercial',
  address: '202 Sunset Boulevard, Coastal City, FL 33101',
  description: 'A strip mall with 8 retail units in a high-traffic area. Anchored by a popular grocery store with additional spaces for smaller businesses.',
  imageUrl: 'https://images.unsplash.com/photo-1519074069444-1ba4fff66d16?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
  size: 24000,
  value: 3900000,
  purchaseDate: '2018-09-05',
  yearBuilt: 2000,
  condition: 'Good',
  currentUse: 'Retail',
  occupancy: 85,
  investmentStrategy: 'Long-Term Hold',
  expectedHoldPeriod: '7-10 years',
  annualCashFlow: 265000,
  capRate: 6.8
}, {
  id: 'prop6',
  name: 'Lakeside Townhomes',
  type: 'Residential',
  address: '303 Lake Drive, Laketown, WA 98001',
  description: 'A development of 16 luxury townhomes on the shores of Lake Washington. Each unit has a private dock and stunning water views.',
  imageUrl: 'https://images.unsplash.com/photo-1512917774080-9991f1c4c750?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=800&q=80',
  size: 28000,
  value: 6700000,
  purchaseDate: '2019-12-15',
  yearBuilt: 2018,
  condition: 'Excellent',
  currentUse: 'Residential Rental',
  occupancy: 94,
  investmentStrategy: 'Short-Term Flip',
  expectedHoldPeriod: '2-3 years',
  projectedProfit: 1200000,
  projectedROI: 17.9
}];
// Mock data for construction projects
export const mockProjects = [{
  id: 'proj1',
  name: 'Riverside Renovation',
  propertyId: 'prop1',
  description: 'Complete renovation of all 24 apartment units including new kitchens, bathrooms, flooring, and energy-efficient windows.',
  status: 'In Progress',
  startDate: '2023-03-10',
  endDate: '2023-09-30',
  duration: 204,
  budget: 960000,
  spent: 420000,
  completedTasks: 12,
  totalTasks: 24,
  tasks: [{
    name: 'Demolition',
    completed: true,
    dueDate: '2023-03-25'
  }, {
    name: 'Plumbing Rough-In',
    completed: true,
    dueDate: '2023-04-15'
  }, {
    name: 'Electrical Rough-In',
    completed: true,
    dueDate: '2023-04-30'
  }, {
    name: 'Window Installation',
    completed: true,
    dueDate: '2023-05-15'
  }, {
    name: 'Drywall Installation',
    completed: false,
    dueDate: '2023-06-15'
  }, {
    name: 'Kitchen Installation',
    completed: false,
    dueDate: '2023-07-30'
  }],
  team: [{
    name: 'John Smith',
    role: 'Project Manager'
  }, {
    name: 'Maria Garcia',
    role: 'Lead Contractor'
  }, {
    name: 'David Wong',
    role: 'Electrician'
  }]
}, {
  id: 'proj2',
  name: 'Office Building HVAC Upgrade',
  propertyId: 'prop2',
  description: 'Replacement of the entire HVAC system with a modern, energy-efficient solution to reduce operating costs and improve tenant comfort.',
  status: 'Planning',
  startDate: '2023-06-15',
  endDate: '2023-10-30',
  duration: 137,
  budget: 750000,
  spent: 125000,
  completedTasks: 2,
  totalTasks: 12,
  tasks: [{
    name: 'Engineering Assessment',
    completed: true,
    dueDate: '2023-05-30'
  }, {
    name: 'System Design',
    completed: true,
    dueDate: '2023-06-30'
  }, {
    name: 'Equipment Procurement',
    completed: false,
    dueDate: '2023-07-30'
  }, {
    name: 'Old System Removal',
    completed: false,
    dueDate: '2023-08-15'
  }, {
    name: 'New System Installation',
    completed: false,
    dueDate: '2023-09-30'
  }, {
    name: 'Testing and Commissioning',
    completed: false,
    dueDate: '2023-10-15'
  }],
  team: [{
    name: 'Sarah Johnson',
    role: 'Project Manager'
  }, {
    name: 'Michael Brown',
    role: 'Mechanical Engineer'
  }, {
    name: 'Lisa Chen',
    role: 'Building Manager'
  }]
}, {
  id: 'proj3',
  name: 'Warehouse Expansion',
  propertyId: 'prop3',
  description: 'Construction of an additional 20,000 sq ft warehouse space to accommodate growing storage needs and installation of a new loading dock.',
  status: 'At Risk',
  startDate: '2023-01-15',
  endDate: '2023-07-30',
  duration: 196,
  budget: 1200000,
  spent: 950000,
  completedTasks: 8,
  totalTasks: 14,
  tasks: [{
    name: 'Site Preparation',
    completed: true,
    dueDate: '2023-02-15'
  }, {
    name: 'Foundation Work',
    completed: true,
    dueDate: '2023-03-15'
  }, {
    name: 'Steel Structure',
    completed: true,
    dueDate: '2023-04-30'
  }, {
    name: 'Roofing',
    completed: true,
    dueDate: '2023-05-30'
  }, {
    name: 'Loading Dock Installation',
    completed: false,
    dueDate: '2023-06-30'
  }, {
    name: 'Interior Finishing',
    completed: false,
    dueDate: '2023-07-15'
  }],
  team: [{
    name: 'Robert Taylor',
    role: 'Project Manager'
  }, {
    name: 'James Wilson',
    role: 'Site Supervisor'
  }, {
    name: 'Emma Martinez',
    role: 'Structural Engineer'
  }]
}, {
  id: 'proj4',
  name: 'Hilltop Residential Development',
  propertyId: 'prop4',
  description: 'Development of 12 luxury single-family homes on the 5-acre parcel, including infrastructure, roads, and landscaping.',
  status: 'Planning',
  startDate: '2023-09-01',
  endDate: '2024-12-31',
  duration: 487,
  budget: 4500000,
  spent: 350000,
  completedTasks: 3,
  totalTasks: 20,
  tasks: [{
    name: 'Land Survey',
    completed: true,
    dueDate: '2023-08-15'
  }, {
    name: 'Architectural Plans',
    completed: true,
    dueDate: '2023-09-30'
  }, {
    name: 'Permits and Approvals',
    completed: true,
    dueDate: '2023-11-15'
  }, {
    name: 'Site Preparation',
    completed: false,
    dueDate: '2023-12-31'
  }, {
    name: 'Infrastructure Installation',
    completed: false,
    dueDate: '2024-03-31'
  }, {
    name: 'Home Construction',
    completed: false,
    dueDate: '2024-10-31'
  }],
  team: [{
    name: 'Patricia Adams',
    role: 'Development Manager'
  }, {
    name: 'Thomas Lee',
    role: 'Architect'
  }, {
    name: 'Olivia Johnson',
    role: 'Civil Engineer'
  }]
}, {
  id: 'proj5',
  name: 'Retail Center Facade Renovation',
  propertyId: 'prop5',
  description: "Modernization of the retail center's exterior facade, including new signage, lighting, and pedestrian-friendly features.",
  status: 'Completed',
  startDate: '2022-10-15',
  endDate: '2023-02-28',
  duration: 136,
  budget: 550000,
  spent: 535000,
  completedTasks: 10,
  totalTasks: 10,
  tasks: [{
    name: 'Design Development',
    completed: true,
    dueDate: '2022-11-15'
  }, {
    name: 'Contractor Selection',
    completed: true,
    dueDate: '2022-11-30'
  }, {
    name: 'Demolition of Old Facade',
    completed: true,
    dueDate: '2022-12-15'
  }, {
    name: 'New Facade Installation',
    completed: true,
    dueDate: '2023-01-31'
  }, {
    name: 'Signage Installation',
    completed: true,
    dueDate: '2023-02-15'
  }, {
    name: 'Final Inspection',
    completed: true,
    dueDate: '2023-02-25'
  }],
  team: [{
    name: 'Daniel Harris',
    role: 'Project Manager'
  }, {
    name: 'Sophia Rodriguez',
    role: 'Designer'
  }, {
    name: 'Kevin Patel',
    role: 'Construction Supervisor'
  }]
}, {
  id: 'proj6',
  name: 'Lakeside Townhomes Pool Addition',
  propertyId: 'prop6',
  description: 'Construction of a community swimming pool and recreation area for the Lakeside Townhomes development.',
  status: 'On Hold',
  startDate: '2023-04-01',
  endDate: '2023-08-31',
  duration: 152,
  budget: 380000,
  spent: 120000,
  completedTasks: 3,
  totalTasks: 12,
  tasks: [{
    name: 'Design and Planning',
    completed: true,
    dueDate: '2023-04-30'
  }, {
    name: 'Permit Acquisition',
    completed: true,
    dueDate: '2023-05-15'
  }, {
    name: 'Site Preparation',
    completed: true,
    dueDate: '2023-05-31'
  }, {
    name: 'Pool Excavation',
    completed: false,
    dueDate: '2023-06-15'
  }, {
    name: 'Pool Construction',
    completed: false,
    dueDate: '2023-07-31'
  }, {
    name: 'Landscaping and Finishing',
    completed: false,
    dueDate: '2023-08-15'
  }],
  team: [{
    name: 'Jennifer White',
    role: 'Project Manager'
  }, {
    name: 'Carlos Sanchez',
    role: 'Pool Contractor'
  }, {
    name: 'Michelle Kim',
    role: 'Landscape Architect'
  }]
}];